import $ from 'jquery';
import {addItemToBasked, removeFavoriteItem} from '../api/api';
import TweenLite from 'TweenLite';
import Power2 from 'TweenLite';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-favorites',
			dom: {
				addToBasket: '.js-add-to-basket',
				remove: '.js-remove',
				list: '.js-favorite-list',
				items: '.js-favorite-item'
			},
			classes: {
				el: {
					state: {
						products: 'favorites_state_products',
						empty: 'favorites_state_empty'
					}

				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);

		this.$el = $(this.options.el);
	}

	getDom() {
		this.$addToBasket = this.$el.find(this.options.dom.addToBasket);
		this.$remove = this.$el.find(this.options.dom.remove);
		this.$list = this.$el.find(this.options.dom.list);
		this.$items = this.$el.find(this.options.dom.items);
	}

	setFavoritesState() {
		const $items = this.$list.find(this.options.dom.items);
		if (!$items.length) {
			this.$el.removeClass(this.options.classes.el.state.products);
			this.$el.addClass(this.options.classes.el.state.empty);
		}
	}

	removeItemAction(e) {
		const $target = $(e.target);
		this.getProId().then(item => this.fetchItem(item)).then(this.removeItem);
		$target.trigger('getId');
		setTimeout(() => {
			this.setFavoritesState();
		}, 500);
	}

	fetchItem(item) {
		return new Promise(resolve => {
			removeFavoriteItem(item.data('id')).then(() => resolve(item));
		});
	}

	removeItem(item) {
		TweenLite.to(item, 0.4, {
			opacity: 0,
			ease: Power2.easeInOut,
			onComplete: () => item.remove()
		});
	}

	addToBasket(e) {
		const $target = $(e.target);
		this.getProId().then(item => addItemToBasked(item.data('id')));
		$target.trigger('getId');
	}

	getProId() {
		return new Promise(( resolve, reject ) => {
			this.$items.on('getId', e => {
				const item = $(e.currentTarget);
				if (item.length) {
					resolve(item);
				} else {
					reject(new Error('atribute not found'));
				}
			});
		});
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.setFavoritesState();
			this.$remove.on('click', e => this.removeItemAction(e));
			this.$addToBasket.on('click', e => this.addToBasket(e));
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/favorites/favorites.js
 **/